module.exports = __webpack_public_path__ + "img/close-arrow-blue.f6f953df.svg";